import { Component, ErrorHandler, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { UserService } from '../../../../shared/user.service';
declare const $: any;

@Component({
  selector: 'app-existingpatientform',
  templateUrl: './existingpatientform.component.html',
  styleUrls: ['./existingpatientform.component.css']
})
export class ExistingpatientformComponent implements OnInit {

  Patient: any = [];
  PatientData: any;
  ClinicalDiscipline: any = [];
  ClinicalDisciplineData: any;
  data: any;
  EP: any = {};
  P: any = {};
  PR_Age: any;
  PR_Id: any;
  mode:any;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,) { }


  ngOnInit() {
    this.GetPatientDropDown();
    this.GetClinicalDisciplineDown();
  }

  GetPatientDropDown() {
    this.PatientData = this.userService.GetPatientDropDown();
    this.PatientData.subscribe(
      (Resp: any) => {
        this.Patient = Resp.Result;
      }
    )
  }

  // GetDoctorDropDown() {
  //   this.DoctorData = this.userService.GetDoctorDropDown();
  //   this.DoctorData.subscribe(
  //     (Resp: any) => {
  //       this.Doctor = Resp.Result;
  //     }
  //   )
  // }

  GetClinicalDisciplineDown() {
    this.ClinicalDisciplineData = this.userService.GetClinicalDisciplineDown();
    this.ClinicalDisciplineData.subscribe(
      (Resp: any) => {
        this.ClinicalDiscipline = Resp.Result;
      }
    )
  }

  GetByIdExistingPatient(PR_Id) {
    debugger;
    this.data = this.userService.GetByIdExistingPatient(PR_Id);
    this.data.subscribe(
      (response: any) => {
        this.P = response;
        if (this.P.PR_DOB != null)
          this.P.PR_DOB = ((this.P.PR_DOB).split('T'))[0];
          this.CalculateAge(response.PR_DOB);
      }, (error) => {
      });
  }

  CalculateAge(dateOfBirth) {
    this.data = this.userService.calculateAge(dateOfBirth);
    this.data.subscribe(
      (response: any) => {
          this.PR_Age = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  CreateExistingPatient(ExistingPatient) {
    debugger;
    // ExistingPatient.PR_Id = PR_Id;
    // this.PR_Id = ExistingPatient.PR_Id;
    this.data = this.userService.CreateExistingPatient(ExistingPatient);
    this.data.subscribe(
      (response) => {
        swal('Success!', 'Existing Patient Details Added Successfully .', 'success');
        this.router.navigate(['/home/existingpatient']);
      }, (error) => {
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/Pages/tasks/existingpatient/existingpatientform/existingpatientform.component.ts